import React from 'react';
import { Modal } from 'antd';
import { ModalContent } from './styled';
import { DEPRECATE_MODAL_CONSTANTS } from './constants';

interface DeprecateModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeprecateModal: React.FC<DeprecateModalProps> = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <Modal
      title={DEPRECATE_MODAL_CONSTANTS.title}
      open={isOpen}
      onOk={onConfirm}
      onCancel={onCancel}
      okText={DEPRECATE_MODAL_CONSTANTS.okText}
      cancelText={DEPRECATE_MODAL_CONSTANTS.cancelText}
      centered
      width={520}
    >
      <ModalContent>
        {DEPRECATE_MODAL_CONSTANTS.content.intro}
        <ul>
          {DEPRECATE_MODAL_CONSTANTS.content.list.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        {DEPRECATE_MODAL_CONSTANTS.content.confirmation}
      </ModalContent>
    </Modal>
  );
};

export default DeprecateModal;
